import { Skeleton } from './Skeleton';
import { cn } from '../../utils/cn';

/**
 * Skeleton SHAPE-MATCHED a la fila de KPI cards (`.summary-cards-container` /
 * `.summary-card`): chip de ícono + número grande + label + mini barra.
 * Compuesto desde el primitivo `ui/Skeleton` (theme-aware, respeta dark mode).
 *
 * Reutiliza el grid responsive `.summary-cards-container` (definido en
 * `_orders-header.scss`) para que el layout coincida exactamente con el real,
 * y replica el padding/borde de `.summary-card` con clases Tailwind para no
 * depender de estados/colores de la card real.
 *
 * Props:
 *  - count: número de cards (default 4)
 *  - showBar: muestra la mini barra inferior (default true)
 *  - className: clases extra para el contenedor.
 */
export function SummaryCardsSkeleton({ count = 4, showBar = true, className }) {
  return (
    <div
      className={cn('summary-cards-container', className)}
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      {Array.from({ length: Math.max(1, count) }).map((_, i) => (
        <div
          key={i}
          className="flex flex-col gap-2 rounded-lg border border-border bg-bg p-3"
        >
          <div className="flex items-start justify-between gap-2">
            {/* Chip de ícono: 2rem x 2rem (= w-8 h-8) como .summary-card__icon */}
            <Skeleton className="h-8 w-8 rounded-md" />
            {/* Número grande */}
            <Skeleton className="h-6 w-12" />
          </div>
          {/* Label */}
          <Skeleton className="h-3 w-2/3" />
          {/* Mini barra (thin bar) */}
          {showBar && <Skeleton className="h-1 w-full rounded-full" />}
        </div>
      ))}
    </div>
  );
}

export default SummaryCardsSkeleton;
